import { Ability, AbilityBuilder, AbilityClass } from '@casl/ability';
import {
    IAooProtocolView, IArxeiaConfiguration, IColonnaGenerale, IFascicolo, IFeature,
    IForwardRule, IMailbox, IMailPecMail, IProtocol, IProtocolRegister, ITitolario, IUor, IUser
} from '../interfaces'
import { IProtocolloAreaDiLavoro } from '../interfacesDTO';


type CRUD = 'create' | 'read' | 'update' | 'delete';
type Abilities = ['create' | 'read' | 'update' |'deleteDraft' | 'sign', IProtocol | 'IProtocol']
    | [CRUD, IUor | 'IUor' | IUser | 'IUser' | ITitolario | 'ITitolario' | IForwardRule | 'IForwardRule' | IFascicolo | 'IFascicolo'
    | IFeature | 'IFeature' | IArxeiaConfiguration | 'IArxeiaConfiguration' | IMailbox | 'IMailbox' | IColonnaGenerale | 'IColonnaGenerale'
    | IAooProtocolView | 'IAooProtocolView' | IProtocolloAreaDiLavoro | 'IProtocolloAreaDiLavoro']
    | ['read' | 'protocol', IMailPecMail | 'IMailPecMail']
    | ['read', IProtocolRegister | 'IProtocolRegister']
    | ['use', IFeature | 'IFeature'];

export type AppAbility = Ability<Abilities>;
export const AppAbility = Ability as AbilityClass<AppAbility>;


const { build } = new AbilityBuilder(AppAbility);


export default build();




